/* eslint-disable react/prop-types */
import React, { useEffect, useState, Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useLoader } from './hooks/useLoader'
import { useAuth } from './contexts/AuthContext'
import { Loader } from './components/Loader' // Import your Loader component

const AppRoutesUnauthorized = () => {
  const [routesConfig, setRoutesConfig] = useState([])
  const { showLoader, hideLoader } = useLoader()
  const { isAuthenticated } = useAuth()

  useEffect(() => {
    const loadRoutes = async () => {
      showLoader()

      // Only load basic routes for unauthorized users
      const basicRoutes = (await import('./routes/BasicAppRoutes')).default

      // Filter out any routes that require authentication
      const publicRoutes = basicRoutes.filter(route => !route.requireAuth)

      setRoutesConfig(publicRoutes)
      hideLoader()
    }

    loadRoutes()
  }, [])

  // Redirect to home if already authenticated
  if (isAuthenticated) {
    return <Navigate to="/" replace />
  }

  return (
    <Routes>
      {routesConfig.map((route, index) => {
        const { element: RouteComponent, ...rest } = route

        return (
          <Route
            key={index}
            {...rest}
            element={
              <Suspense fallback={<Loader />}>
                <RouteComponent />
              </Suspense>
            }
          />
        )
      })}
    </Routes>
  )
}

export default AppRoutesUnauthorized
